<footer class="footer-container">
  <div class="mb-2">
    <a
      class="link"
      href="https://apps.apple.com/us/app/camp-bow-wow/id365208471"
      alt="Download on the App Store"
      target="_blank"
    >
      <img
        src="assets/images/badge_app-store.png"
        alt="Download on the App Store"
        height="40"
        class="mb-1"
        style="margin-right: 1.25rem;"
      >
    </a>
    <a
      class="link"
      href="https://play.google.com/store/apps/details?id=com.campbowwow.android&hl=en_US&gl=US"
      alt="Get it on Google Play"
      target="_blank"
    >
      <img
        src="assets/images/badge_google-play.png"
        alt="Get it on Google Play"
        height="40"
        class="mb-1"
      >
    </a>
  </div>
  <div class="row no-gutters justify-content-between align-items-center">
    <div class="col-12 col-md-auto mb-3 mb-md-0">
      <div>
        <a
          class="link"
          href="https://www.campbowwow.com/about-us/faqs/account"
          target="_blank"
          (click)="logHelp()"
        >Help</a>
        <span class="pipe"> | </span>
        <a
          class="link"
          href="https://www.bowwowbuddies.com/"
          target="_blank"
          (click)="logBWB()"
        >Bow Wow Buddies Foundation<sup>&#174;</sup></a>
        <span class="pipe"> | </span>
        <a
          class="link"
          href="https://www.campbowwow.com/"
          target="_blank"
          (click)="logLegal()"
        >Legal</a>
        <span class="pipe"> | </span>
        <a
          class="link"
          href="https://www.campbowwow.com/privacy-policy/"
          target="_blank"
          (click)="logPS()"
        >Privacy & Security</a>
        <span class="pipe"> | </span>
        <a
          class="link"
          href="https://www.campbowwow.com/terms-of-use/"
          target="_blank"
          (click)="logTOS()"
        >Terms of Use</a>
        <span class="pipe"> | </span>
        <a
          class="link"
          href="https://www.campbowwow.com/accessibility/"
          target="_blank"
          (click)="logAccessibility()"
        >Accessibility</a>
      </div>
      <div class="lato copyright">Copyright &copy;{{ copyrightYear }} Camp Bow Wow<sup>&#174;</sup>. All rights reserved. Version {{versionInfo}}</div>
    </div>
    <div class="col-12 col-md-auto">
      <a
        class="link"
        href="https://www.campbowwow.com/"
        (click)="logCBW()"
        target="_blank"
      >
        <img
          src="assets/images/cbw-logo-horizontal.png"
          alt="Camp Bow Wow"
          width="200"
        >
      </a>
    </div>
  </div>
</footer>
